(function() {
    function RunTimeFormatter() {
        return function(runtime) {
            runtime = Number(runtime);      
            var hours = Math.floor(runtime / 60);
            var minutes = runtime % 60;
            return hours + "h " + minutes + "m";
        };
    }
    RunTimeFormatter.$inject = [];
    angular
        .module("cstudioApp.filters")
        .filter("RunTimeFormatter", RunTimeFormatter);
})();